import React from "react";
import {
    Card,
    CardContent,
    CardMedia,
    Chip,
    Divider,
    Grid,
    ListItemButton,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import Typography from "@mui/material/Typography";
import {MyListItem} from "../header/header.styled";

interface ComponentProps {
    title: string;
    url: string;
    bgImage?: string;
    icon?: any;
}

export default function Thumbnail({title, url, bgImage, icon}: ComponentProps) {
    const navigate = useNavigate();

    return (
        <MyListItem sx={{ margin: "0.5rem" }} key={title + "-" + url}>
            <ListItemButton
                onClick={() => {
                    navigate(url);
                }}
            >
                { /* This is element's icon */}
                <ListItemIcon sx={{
                    color: "#202124"
                }}>{icon}</ListItemIcon>

                { /* This is element's text */}
                <ListItemText primary={title}/>
            </ListItemButton>
        </MyListItem>
    );

    /*return <div style={{
        maxWidth: "500px",
        width: "100%",
        height: "auto",
    }}>
        <Link
            to={url}
            style={{textDecoration: "none"}}
        >
            <Card
                sx={{
                    maxWidth: 400,
                    width: "100%",
                    background: "#fff",
                    border: "1px solid #777",
                    borderRadius: 5,
                    height: "100px",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    transition: "transform 0.2s",
                    "&:hover": {
                        transform: "scale(1.05)",
                    },
                }}
            >
                <CardContent
                    sx={{
                        zIndex: 1,
                        color: "#111",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            width: "100%",
                            maxHeight: "100%",
                        }}
                    >
                        {title}
                    </Typography>
                </CardContent>
            </Card>
        </Link>
    </div> */
}